import {useQuery} from '@tanstack/react-query';
import {directoryAdapter} from '../adapters/directory';
import type {DirectorySource} from '../types/directory';

export function useDirectoryTree(
  rootId: number | string = 1,
  source: DirectorySource = 'directory',
  userId?: number | string
) {
  return useQuery({
    queryKey: ['directory-tree', source, rootId, userId],
    queryFn: () => directoryAdapter.getChildren(Number(rootId), source, Number(rootId)),
    enabled: !!userId,
    staleTime: 0,
    cacheTime: 30 * 60 * 1000,
    refetchOnMount: true,
  });
}
